import countries, { LocalizedCountryNames } from "i18n-iso-countries";

import i18n from "../../services/i18n";

export const countryList = (type: "eu" | "all") => {
  let language = "de";
  if (i18n.language && i18n.language.startsWith("en")) {
    language = "en";
  }

  const euCodes = [
    "AT",
    "BE",
    "BG",
    "HR",
    "CY",
    "CZ",
    "DK",
    "EE",
    "FI",
    "FR",
    "DE",
    "GR",
    "HU",
    "IE",
    "IT",
    "LV",
    "LT",
    "LU",
    "MT",
    "NL",
    "PL",
    "PT",
    "RO",
    "SK",
    "SI",
    "ES",
    "SE",
  ];
  const langCountries: LocalizedCountryNames<{
    select: "official";
  }> = countries.getNames(
    language,
    { select: "official" }
  );

  if (type === "eu") {
    return Object.entries(langCountries)
      .filter(([countryCode]) => euCodes.indexOf(countryCode) > 1)
      .map(([countryCode, countryName]) => ({
        label: countryName,
        code: countryCode,
      }));
  } else {
    return Object.entries(langCountries)
      .filter(([countryCode]) => euCodes.indexOf(countryCode) === -1)
      .map(([countryCode, countryName]) => ({
        label: countryName,
        code: countryCode,
      }));
  }
};
